// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NrAt","label":"styles_label__ozikX"};